module.exports = __webpack_public_path__ + "static/fannywautelet-45d78ab78b71f7b6f847c4b29ed07ba1.jpg";